<!--
  - Copyright (c) 2023 by 安徽网才信息技术股份有限公司
  -
  - 除非事先获得版权所有人的许可, 禁止以下几项行为:
  - 1. 对该软件的任何源代码和技术文档进行任意形式的打包、分发或复制用于其他目的。
  - 2. 向第三方透露任何与该软件相关的源代码或技术文档。
  - 3. 更改或删除软件或源码中的版权声明。
  -
  -->
<template>
    <div>
        <div class="feedback">
            <div class="feedback-btn" @click="handleFeedback">
                <i class="el-icon-warning-outline"></i><br />
                <span class="fk-text">反馈</span>
            </div>
        </div>
        <el-dialog
            :visible.sync="dialogVisible"
            width="30%"
            :before-close="handleClose"
        >
            <!--  反馈信息提交表单          -->
            <el-form ref="feedbackForm" :model="form" :rules="rules" label-width="80px">
                <el-form-item label="反馈类型" prop="type">
                    <el-select v-model="form.type" placeholder="请选择反馈类型">
                        <el-option label="项目咨询" value="1" />
                        <el-option label="使用异常" value="2" />
                        <el-option label="吐槽" value="3" />
                        <el-option label="建议" value="4" />
                        <el-option label="个人信息安全投诉/举报" value="5" />
                        <el-option label="其他" value="6" />
                    </el-select>
                </el-form-item>
                <el-form-item label="反馈内容" prop="content">
                    <el-input
                        v-model="form.content"
                        type="textarea"
                        :rows="5"
                        maxlength="200"
                        show-word-limit
                        placeholder="请输入反馈内容"
                    />
                </el-form-item>
                <el-form-item label="项目">
                    <el-select v-model="form.projectId" clearable placeholder="请选择项目" style="width: 100%;">
                        <el-option
                            v-for="item in projects"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                        />
                    </el-select>
                </el-form-item>
                <el-form-item label="图片">
                    <el-upload
                        ref="feedback-upload"
                        :limit="5"
                        :action="uploadUrl"
                        :headers="headers"
                        accept="image/*"
                        list-type="picture-card"
                        :with-credentials="true"
                        :before-upload="handleBeforeUpload"
                        :on-preview="handlePictureCardPreview"
                        :on-remove="handleRemove"
                        :on-success="handleUploadSuccess"
                        :on-error="handleUploadOnError"
                    >
                        <i class="el-icon-plus"></i>
                    </el-upload>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="handleSubmit">提 交</el-button>
            </span>
        </el-dialog>
        <!--    图片预览    -->
        <el-dialog :visible.sync="dialogVisibleView">
            <img width="100%" :src="dialogImageUrl" alt="" />
        </el-dialog>
    </div>
</template>

<script>
import { projectAll } from '@/api/project';
import { saveFeedback } from '@/api/common';
import Cookies from 'js-cookie';
export default {
    name: 'Feedback',
    data() {
        return {
            dialogVisible: false,
            dialogVisibleView: false,
            form: {
                source: 1,
                type: '',
                content: '',
                projectId: '',
                images: []
            },
            dialogImageUrl: '',
            projects: [],
            uploadUrl: this.$config.apiBaseUrl + '/frontend/upload',
            headers: {
                'X-Xsrf-Token': Cookies.get('XSRF-TOKEN'),
                'X-Agent': this.$store.state.agent
            },
            rules: {
                type: [
                    { required: true, message: '请选择反馈类型', trigger: 'blur' }
                ],
                content: [
                    { required: true, message: '请输入反馈内容', trigger: 'blur' }
                ]
            }
        };
    },
    created() {
    },
    methods: {
        handleClose() {
            this.dialogVisible = false;
        },
        handleFeedback() {
            // 判断是否登录
            if (!this.$store.state.userInfo) {
                this.$message.error('请先登录再反馈');
                this.$router.push({ name: 'login' });
                return;
            }
            // 表单数据重置
            this.form = {
                source: 1,
                type: '',
                content: '',
                projectId: '',
                images: []
            };
            // 图片重置
            if (this.$refs['feedback-upload'] !== undefined) {
                this.$refs['feedback-upload'].clearFiles();
            }
            this.dialogVisible = true;
            this.handleProjectList();
        },
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisibleView = true;
        },
        handleRemove(file, fileList) {
            // 删除图片时将form中的图片地址删除
            this.form.images.splice(this.form.images.indexOf(file.url), 1);
        },
        async handleProjectList() {
            await projectAll().then(res => {
                this.projects = res.data;
            });
        },
        handleBeforeUpload(file) {
            // 只要是图片格式就可以上传
            const isJPG = file.type === 'image/jpeg';
            const isPNG = file.type === 'image/png';
            const isGIF = file.type === 'image/gif';
            const isBMP = file.type === 'image/bmp';
            const isLt2M = file.size / 1024 / 1024 < 6;
            if (!(isJPG || isPNG || isGIF || isBMP)) {
                this.$message.error('上传图片只能是 JPG/PNG/GIF/BMP 格式!');
            }
            if (!isLt2M) {
                this.$message.error('上传图片大小不能超过 6MB!');
            }
            return (isJPG || isPNG || isGIF || isBMP) && isLt2M;
        },
        handleUploadSuccess(response, file, fileList) {
            // 上传成功将返回的图片地址放入form中
            this.form.images.push(response.data);
        },
        handleUploadOnError(err, file, fileList) {
            this.$message.error('上传失败');
        },
        handleSubmit() {
            this.$refs.feedbackForm.validate(valid => {
                if (valid) {
                    saveFeedback(this.form);
                    this.$message.success('提交成功');
                    this.dialogVisible = false;
                } else {
                    this.$message.error('提交失败');
                    return false;
                }
            });
        }
    }
};
</script>

<style scoped>
.feedback {
    position: fixed;
    right: 20px;
    bottom: 20px;
    z-index: 999;
    .feedback-btn {
        width: 50px;
        height: 50px;
        border-radius: 50%;
        //background-color: #fff;
        //box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
        cursor: pointer;
        text-align: center;
        .el-icon-warning-outline {
            font-size: 28px;
            line-height: 26px;
            text-align: center;
        }
        .fk-text {
            font-size: 14px;
            color: #999;
        }
    }
    .feedback-btn:hover {
        .el-icon-warning-outline {
            color: #409eff;
        }
        .fk-text {
            color: #409eff;
        }
    }
}
</style>
